export default __webpack_public_path__ + "84754003b4f53a4ffa0e763d3b1b69c7.png";